// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"134":"df48f661","193":"c0fb35d6","219":"1e93c631","286":"c0fb35d6","364":"c0fb35d6"}[chunkId] + ".chunk.css";
};